import * as React from 'react';

function SvgLockIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} fill="none" height="20" viewBox="0 0 17 20" width="17" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.6201 11.5V14.5M1 7.92736V18.3184H16.2402V7.92736H1ZM3.77094 7.92736C3.77094 3.77094 3.77094 1 8.6201 1C13.4692 1 13.4692 3.77094 13.4692 7.92736H3.77094Z"
        stroke="#00E889"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M8.62047 12.8547C9.00306 12.8547 9.31321 12.5446 9.31321 12.162C9.31321 11.7794 9.00306 11.4692 8.62047 11.4692C8.23788 11.4692 7.92773 11.7794 7.92773 12.162C7.92773 12.5446 8.23788 12.8547 8.62047 12.8547Z"
        stroke="#00E889"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export default SvgLockIcon;
